export default __webpack_public_path__ + "static/media/step4.2a7766e3.svg";